import React from 'react';
import { X, Download, Trash2, Eye } from 'lucide-react';
import { Asset } from './FileExplorer';

interface FileDetailsProps {
  asset: Asset;
  onClose: () => void;
  onDelete: (asset: Asset) => void;
  isPicker?: boolean;
}

export const FileDetails: React.FC<FileDetailsProps> = ({
  asset,
  onClose,
  onDelete,
  isPicker = false,
}) => {
  const isImage = asset.mimeType.startsWith('image/');

  const handleDownload = () => {
    window.open(asset.originalFile, '_blank');
  }

  return (
    <div className="fixed inset-0 bg-neutral-900 bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-xl max-w-2xl w-full animate-fade-in-up">
        <div className="flex justify-between items-center p-4 border-b border-gray-200">
          <h2 className="text-lg sm:text-xl font-medium">File Details</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 hover:bg-gray-100 p-1 rounded-md transition duration-200 ease-in-out"
            aria-label="Close modal"
          >
            <X size={20} />
          </button>
        </div>
        <div className="p-6">
          {isImage && (
            <div className="mb-4 bg-neutral-100 rounded-xl overflow-hidden">
              <img
                src={asset.thumnailImage}
                alt={asset.filename}
                className="max-h-64 w-full object-contain"
              />
            </div>
          )}
          <div className="space-y-6 mb-4">
            <p className="text-sm text-gray-500">
              <span className="font-medium text-neutral-700">Filename:</span> {asset.filename}
            </p>
            <p className="text-sm text-gray-500">
              <span className="font-medium text-neutral-700">Type:</span> {asset.mimeType}
            </p>
            <p className="text-sm text-gray-500">
              <span className="font-medium text-neutral-700">Size:</span> {(asset.size / 1024 / 1024).toFixed(2)} MB
            </p>
            <p className="text-sm text-gray-500">
              <span className="font-medium text-neutral-700">Path:</span> {asset.originalFile}
            </p>
            <p className="text-sm text-gray-500">
              <span className="font-medium text-neutral-700">Last Modified:</span> {new Date(asset.updatedAt || '').toLocaleString()}
            </p>
          </div>
          <div className="flex flex-wrap justify-end gap-3">
            {isImage && (
              <button
                onClick={() => window.open(asset.originalFile, '_blank')}
                className="px-4 py-2 bg-neutral-100 text-neutral-700 rounded-md hover:bg-neutral-200 transition duration-200 ease-in-out flex items-center text-sm"
              >
                <Eye size={16} className="mr-2" />
                View
              </button>
            )}
            <button
              onClick={handleDownload}
              className="px-4 py-2 bg-primary-50 text-blue-500 rounded-md hover:bg-primary-100 transition duration-200 ease-in-out flex items-center text-sm"
            >
              <Download size={16} className="mr-2" />
              Download
            </button>
            {!isPicker && (
              <button
                onClick={() => onDelete(asset)}
                className="px-4 py-2 bg-accent-50 text-accent-700 rounded-md hover:bg-accent-100 transition duration-200 ease-in-out flex items-center text-sm"
              >
                <Trash2 size={16} className="mr-2" />
                Delete
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};